import { TableHeadItemRecurse } from '../../components/TableHead';

export const dividendsHistoryTableHead: TableHeadItemRecurse[] = [
  {
    title: 'Tipo',
    flex: 1,
  },
  {
    title: 'Empresa',
    flex: 1,
  },
  {
    title: 'ISIN',
    flex: 1,
  },
  {
    title: 'Cód. Neg.',
    flex: 1,
  },
  {
    title: 'Ativo',
    flex: 1,
  },
  {
    title: 'Valor',
    flex: 1,
  },
  {
    title: 'Aprovação',
    flex: 1,
  },
  {
    title: 'Início',
    flex: 1,
  },
  {
    title: 'Atualização',
    flex: 1,
  },
  {
    title: 'Prazo Final',
    flex: 1,
  },
];
